import { queryOptions } from '@tanstack/react-query';
import type { SessionUser } from '@vision360/contracts';
import type { Session } from '@/lib/auth/session';

/**
 * The signed-in user is server state, so it lives in TanStack Query rather
 * than Zustand (TechSpec §8.1). `null` means signed out.
 */
export const SESSION_KEY = ['session'] as const;

export function sessionQuery(session: Session) {
  return queryOptions<SessionUser | null>({
    queryKey: SESSION_KEY,
    queryFn: () => session.bootstrap(),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
